import { createFileRoute } from '@tanstack/react-router'
import { AboutEvents } from '@/features/about/components/about-events'
import { AboutHero } from '@/features/about/components/about-hero'
import { AboutMascot } from '@/features/about/components/about-mascot'
import { AboutPartners } from '@/features/about/components/about-partners'
import { AboutPress } from '@/features/about/components/about-press'
import { AboutQuality } from '@/features/about/components/about-quality'
import { AboutTeam } from '@/features/about/components/about-team'
import { AboutVideo } from '@/features/about/components/about-video'
import { TailoredSection } from '@/features/landing-page/components/tailored-section'
import { DEFAULT_FAQ_ITEMS, FaqSection } from '@/features/landing-page/components/faq-section'
import { FinalCtaSection } from '@/features/landing-page/components/final-cta-section'
import { getTranslations } from '@/i18n/translator'
import { pageHead, SITE_URL } from '@/lib/seo'
import { breadcrumbSchema, faqSchema, homeBreadcrumbItem } from '@/lib/structured-data'
import { useScrollDepth } from '@/lib/analytics/use-scroll-depth'
import { trackAboutCtaClick } from '@/lib/analytics/events'

const PATH = '/about'

export const Route = createFileRoute('/$locale/about')({
  loader: async ({ params }) => {
    const [t, faqT] = await Promise.all([
      getTranslations({ locale: params.locale, namespace: 'about' }),
      getTranslations({ locale: params.locale, namespace: 'home.faq' }),
    ])
    const faq = DEFAULT_FAQ_ITEMS.map((key) => ({
      question: faqT(`items.${key}.question`),
      answer: faqT(`items.${key}.answer`),
    }))
    return { title: t('meta.title'), description: t('meta.description'), faq }
  },
  head: ({ loaderData, params }) => {
    const url = `${SITE_URL}/${params.locale}${PATH}`
    const breadcrumbLd = breadcrumbSchema([
      homeBreadcrumbItem(params.locale),
      { name: loaderData?.title ?? '', url },
    ])
    const faqLd = faqSchema(loaderData?.faq)
    return pageHead({
      locale: params.locale,
      path: PATH,
      title: loaderData?.title ?? '',
      description: loaderData?.description ?? '',
      jsonLd: faqLd ? [breadcrumbLd, faqLd] : breadcrumbLd,
    })
  },
  component: About,
})

function About() {
  useScrollDepth('about')
  return (
    <>
      <AboutHero />
      <AboutVideo />
      <AboutQuality />
      <AboutMascot />
      <AboutTeam />
      <AboutPartners />
      <AboutEvents />
      <AboutPress />
      <FaqSection />
      <FinalCtaSection onCtaClick={trackAboutCtaClick} />
    </>
  )
}
